export default __webpack_public_path__ + "static/media/2_1.b57c00e4.jpg";